import React, {useContext, useEffect, useState} from 'react'
import {RecipeConText} from "../../../../../context/RecipeContext";
import {Col, Row} from "antd";

const RecipeItemsMidTotal = () => {
    const [total, setTotal] = useState(0)
    const {subTotals} = useContext(RecipeConText)

    useEffect(() => {
        let total = 0
        Object.keys(subTotals).map(key => {
            total += subTotals[key].reduce((first, second) => first + second, 0)
        })
        setTotal(total)
    }, [subTotals])

    return (
        <React.Fragment>
            <Row justify={"end"} align={"start"}>
                <Col span={14}>
                    <h6>Malzeme Giderleri Alt Toplam :</h6>
                </Col>
                <Col span={5}>
                    {
                        <span>{new Intl.NumberFormat().format(total)} USD</span>
                    }
                </Col>
            </Row>
        </React.Fragment>
    )
}
export default RecipeItemsMidTotal